const module = angular.module('webremote.directive.objectmanager.wizard')

module.controller('webremote.directive.objectmanager.wizard.pagination.controller', ['$scope', 'objectManagerService', 'httpService', '$uibModal', function ($scope, objectManagerService, httpService, $uibModal) {
  $scope.shouldShowItem = (item) => {
    if (!item.condition) return true
    const objectPath = require('object-path')
    const unionObj = objectPath.get($scope.object.member, item.condition.path)
    if (!unionObj) return true
    return Object.keys(unionObj)[0] === item.condition.unionValue
  }

  $scope.previousButton = {
    disabled: false,
    text: 'Previous',
    class: 'btn btn-xs btn-default',
    action: () => {
      if (
        $scope.pointer.subMenuIndex > 0
      ) {
        $scope.pointer.subMenuIndex--
      } else {
        let prevIndex = $scope.pointer.mainMenuIndex - 1
        while (prevIndex >= 0 && !$scope.shouldShowItem($scope.menuConfig[prevIndex])) {
          prevIndex--
        }
        $scope.pointer.mainMenuIndex = prevIndex
        $scope.pointer.subMenuIndex = $scope.getSubItemQuantity($scope.menuConfig[prevIndex])
      }
    }
  }

  $scope.nextButton = {
    disabled: false,
    text: 'Next',
    class: 'btn btn-xs btn-default',
    action: () => {
      if (
        $scope.getSubItemQuantity($scope.menuConfig[$scope.pointer.mainMenuIndex]) > 0 &&
        $scope.pointer.subMenuIndex < $scope.getSubItemQuantity($scope.menuConfig[$scope.pointer.mainMenuIndex])
      ) {
        $scope.pointer.subMenuIndex++
      } else {
        let nextIndex = $scope.pointer.mainMenuIndex + 1
        while (nextIndex < $scope.menuConfig.length && !$scope.shouldShowItem($scope.menuConfig[nextIndex])) {
          nextIndex++
        }
        $scope.pointer.mainMenuIndex = nextIndex
        $scope.pointer.subMenuIndex = 0
      }
    }
  }

  $scope.getSubItemQuantity = (mainMenuItem) => {
    try {
      if (Object.keys(mainMenuItem.subMenu)[0] === 'items') {
        return mainMenuItem.subMenu.items.length
      }

      if (Object.keys(mainMenuItem.subMenu)[0] === 'genericList') {
        return require('object-path').get($scope.object.member, mainMenuItem.subMenu.genericList.content.configForm.path.replace(/\.fields/g, '').replace(/\.elementType/g, '')).length
      }
    } catch (e) {
      return 0
    }
  }

  $scope.$watch('pointer', (newValue) => {
    // Find first and last visible menu indices (skipping hidden union variants)
    let firstVisible = 0
    while (firstVisible < $scope.menuConfig.length && !$scope.shouldShowItem($scope.menuConfig[firstVisible])) {
      firstVisible++
    }
    let lastVisible = $scope.menuConfig.length - 1
    while (lastVisible >= 0 && !$scope.shouldShowItem($scope.menuConfig[lastVisible])) {
      lastVisible--
    }

    // Check if the back button should be deactivated
    if ($scope.pointer.mainMenuIndex === firstVisible && $scope.pointer.subMenuIndex === 0) {
      $scope.previousButton.disabled = true
    } else {
      $scope.previousButton.disabled = false
    }

    // Check if the next button should be deactivated
    if (
      Array.isArray($scope.menuConfig) &&
      $scope.pointer.mainMenuIndex === lastVisible &&
      $scope.pointer.subMenuIndex === $scope.getSubItemQuantity($scope.menuConfig[lastVisible])
    ) {
      $scope.nextButton.disabled = true
    } else {
      $scope.nextButton.disabled = false
    }
  }, true)
}])

  .directive('omWizardPagination', function () {
    return {
      restrict: 'E',
      scope: {
        menuConfig: '<menuConfig',
        pointer: '=pointer',
        object: '<object'
      },
      controller: 'webremote.directive.objectmanager.wizard.pagination.controller',
      templateUrl: 'directives/objectmanager/wizard/pagination/template.html'
    }
  })
